// 專題 返回列表
import Link from "next/link";

const ProjectBack = () => {
  return (
    <div className="return mt-[70px] mb-[30px] umd:mt-[50px] umd:mb-[0]">
      <Link href="/project">返回列表</Link>
    </div>
  );
};

export default ProjectBack;
